(() => {
  class FurnitureProductReviews {
    constructor(root) {
      this.root = root;
      this.perPage = Math.max(1, parseInt(root.dataset.perPage || '5', 10) || 5);
      this.cards = [...root.querySelectorAll('[data-fpr-card]')];
      this.list = root.querySelector('[data-fpr-list]');
      this.pager = root.querySelector('[data-fpr-pager]');
      this.sort = root.querySelector('[data-fpr-sort]');
      this.page = 1;

      this.sort?.addEventListener('change', () => {
        this.sortCards();
        this.page = 1;
        this.render();
      });

      this.sortCards();
      this.render();
    }

    sortCards() {
      const mode = this.sort?.value || 'highest';
      this.cards.sort((a, b) => {
        const ra = Number(a.dataset.rating || 0);
        const rb = Number(b.dataset.rating || 0);
        const da = Number(a.dataset.date || 0);
        const db = Number(b.dataset.date || 0);
        if (mode === 'highest') return rb - ra || db - da;
        if (mode === 'newest') return db - da;
        if (mode === 'oldest') return da - db;
        return 0;
      });
      this.cards.forEach((card) => this.list.appendChild(card));
    }

    render() {
      const total = this.cards.length;
      const pages = Math.max(1, Math.ceil(total / this.perPage));
      if (this.page > pages) this.page = pages;

      this.cards.forEach((card, i) => {
        const start = (this.page - 1) * this.perPage;
        const end = start + this.perPage;
        card.hidden = !(i >= start && i < end);
      });

      if (!this.pager) return;
      if (pages <= 1) {
        this.pager.hidden = true;
        this.pager.innerHTML = '';
        return;
      }

      this.pager.hidden = false;
      this.pager.innerHTML = '';

      const prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'fpr__page-btn';
      prev.textContent = '‹';
      prev.disabled = this.page <= 1;
      prev.addEventListener('click', () => {
        this.page -= 1;
        this.render();
      });
      this.pager.appendChild(prev);

      for (let p = 1; p <= pages; p += 1) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'fpr__page-btn' + (p === this.page ? ' is-active' : '');
        btn.textContent = String(p);
        btn.addEventListener('click', () => {
          this.page = p;
          this.render();
        });
        this.pager.appendChild(btn);
      }

      const next = document.createElement('button');
      next.type = 'button';
      next.className = 'fpr__page-btn';
      next.textContent = '›';
      next.disabled = this.page >= pages;
      next.addEventListener('click', () => {
        this.page += 1;
        this.render();
      });
      this.pager.appendChild(next);
    }
  }

  document.querySelectorAll('[data-fpr]').forEach((el) => {
    if (!el._fpr) el._fpr = new FurnitureProductReviews(el);
  });
})();
